export function TeamSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/team.svg'"></ng-include>`
    }
}